<template>
  <ul v-if="admins.length > 0" class="space-y-2">
    <li v-for="admin in admins" :key="admin.email">
      <div
        class="relative grid grid-cols-6 gap-2 rounded-lg border border-background-fg/8 px-4 py-2 shadow-sm md:grid-cols-12"
      >
        <div class="col-span-4 line-clamp-1 font-semibold">
          {{ admin.email }}
        </div>

        <button
          class="col-span-2 text-sm font-medium text-info/87 md:col-span-4"
          @click="sendLoginLink(admin.email)"
          >Send login link</button
        >

        <BaseInnerLoading
          v-if="
            loginLinkIsBeingSentFormEmail === admin.email
          "
        />
      </div>
    </li>
  </ul>

  <p v-else class="text-center"
    >No admins associated with this merchant group</p
  >
</template>

<script setup lang="ts">
import type { MerchantGroupAdmin } from "@/services/merchants/retrieveMerchantGroup"

const props = defineProps<{
  admins: Array<MerchantGroupAdmin>
}>()

const loginLinkIsBeingSentFormEmail = ref<string | null>(
  null
)

const sendLoginLink = async (email: string) => {
  try {
    loginLinkIsBeingSentFormEmail.value = email
    await sendMerchantGroupAdminLoginLink({ email: email })
    toast.success("Email sent")
  } catch (error) {
    if (error instanceof ApiError) {
      if (
        error.code === "merchant-group-admin-has-no-group"
      ) {
        toast.error(
          "This email is not associated with a merchant group"
        )
      } else if (
        error.code === "merchant-group-admin-not-found"
      ) {
        toast.error(
          "An admin associated with this email could not be found"
        )
      } else {
        toast.error("Failed to send email link")
      }
    }
  } finally {
    loginLinkIsBeingSentFormEmail.value = null
  }
}
</script>
